export const SHOPS_LOADING = 'SHOPS_LOADING'
export const SHOPS_COMPLETE = 'SHOPS_COMPLETE'
export const SHOPS_ERROR = 'SHOPS_ERROR'

export const SHOPS_SEARCHED_LOADING = 'SHOPS_SEARCHED_LOADING'
export const SHOPS_SEARCHED_COMPLETE = 'SHOPS_SEARCHED_COMPLETE'
export const SHOPS_SEARCHED_ERROR = 'SHOPS_SEARCHED_ERROR'

export const GET_SERVICES_LOADING = 'GET_SERVICES_LOADING'
export const GET_SERVICES_COMPLETE = 'GET_SERVICES_COMPLETE'
export const GET_SERVICES_ERROR = 'GET_SERVICES_ERROR'

export const SHOP_DETAIL_LOADING = 'SHOP_DETAIL_LOADING'
export const SHOP_DETAIL_COMPLETE = 'SHOP_DETAIL_COMPLETE'
export const SHOP_DETAIL_ERROR = 'SHOP_DETAIL_ERROR'

export const SHOP_CURRENT_CLEAN = 'SHOP_CURRENT_CLEAN'

export const PRODUCT_UPDATE = 'PRODUCT_UPDATE'
export const PRODUCTS_FILTER = 'PRODUCTS_FILTER'
export const PRODUCTS_FILTER_CLEAN = 'PRODUCTS_FILTER_CLEAN'
export const PRODUCTS_UPDATE_FILTER_SELECTED = 'PRODUCTS_UPDATE_FILTER_SELECTED'
export const SERVICES_UPDATE = 'SERVICES_UPDATE'
export const SERVICES_CLEAN = 'SERVICES_CLEAN'


//////////////////
// WEBPACK FOOTER
// ../nonameapp-common-modules/src/store/modules/shops/mutation-types.js
// module id = null
// module chunks = 